import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import App from './App.js';
import './index.css';

//----pending:::THE KEY NEED TO BE MOVED INTO GIT ENV VAIABLES FOR PRODUCTION
if(process.env.REACT_APP_SENTRY_KEY){
  Sentry.init({
    dsn: `${process.env.REACT_APP_SENTRY_KEY}`,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0,
  });
}


const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
